import { DataSource } from 'hooks/useHttpClient';
import { BasicMappedStatus } from './Candidate';

export type Document = {
    id: string;
    name: string;
    type: string;
    url?: string;
};
export const DocumentTypes: BasicMappedStatus[] = [
    { id: 0, name: 'Legal' },
    { id: 1, name: 'Jobs' },
    { id: 2, name: 'Misc' },
    { id: 3, name: 'Other' }
];

export const OnboardingDocumentTypes: BasicMappedStatus[] = [
    { id: 0, name: 'Legal' },
    { id: 2, name: 'Misc' },
    { id: 3, name: 'Other' }
];

export const DocumentTypesMap: { [key: string]: string } = {
    pdf: 'application/pdf',
    png: 'image/png',
    jpg: 'image/jpg',
    jpeg: 'image/jpeg',
    csv: 'text/csv',
    doc: 'application/msword',
    docx: 'application/msword',
    txt: 'text/plain',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.ms-excel',
    pptx: 'application/vnd.ms-powerpoint',
    ppt: 'application/vnd.ms-powerpoint'
};

export const getDocumentType = (fullName: string): string => {
    const extension = fullName.split('.').pop();
    return DocumentTypesMap[extension || 'invalid'] || 'invalid';
};

export const isImageDocument = (type: string): boolean => getDocumentType(type)?.includes('image');

export function DocumentListResolver(dataSource: DataSource, apiResponse: any): Document[] {
    if (!apiResponse) {
        return [];
    }
    try {
        switch (dataSource) {
            case 'hyrerocket':
                return apiResponse.map((document: any) => ({
                    id: document.id,
                    name: document.attachment || document.document,
                    type: document.type
                }));

            default:
                return [];
        }
    } catch (error) {
        // console.error(error);
        return [];
    }
}
